import React from "react";
import "../Provide/Provide.css";

const cardData = [
  {
    id: 1,
    imgSrc: "s1.webp",
    title: "Exploration and Surveying",
    description:
      "We specialize in geological exploration and surveying to locate and evaluate mineral resources.",
  },
  {
    id: 2,
    imgSrc: "s2.webp",
    title: "Resource Extraction",
    description:
      "Our team is skilled in the extraction of valuable minerals and metals using safe and efficient methods.",
  },
  {
    id: 3,
    imgSrc: "s3.webp",
    title: "Mining Safety & Risk Management",
    description:
      "We implement rigorous safety protocols and risk management practices to ensure the well-being of our workers.",
  },
  {
    id: 4,
    imgSrc: "s4.webp",
    title: "Environmental Management",
    description:
      "We prioritize sustainable mining practices, focusing on minimizing environmental impact and promoting rehabilitation efforts.",
  },
  {
    id: 5,
    imgSrc: "s5.webp",
    title: "Logistics and Transportation",
    description:
      "We offer reliable transportation services for the safe and efficient movement of mined materials to processing facilities.",
  },
  {
    id: 6,
    imgSrc: "s6.webp",
    title: "Consulting and Project Management",
    description:
      "Our experts provide strategic consulting and project management services to optimize mining operations and maximize profitability.",
  },
];

const Provide = () => {
  return (
    <section className="provide-p">
      <div className="heading-container-p">
        <p className="section-heading-p">What We Provide</p>
        <h1 className="section-title-p">We offering best services</h1>
      </div>

      <div className="cards-container-p">
        {cardData.map((card) => (
          <div className="card-p" key={card.id}>
            <img src={card.imgSrc} alt={card.title} className="card-img-p" />
            <h4 className="card-title-p">{card.title}</h4>
            <p className="card-description-p">{card.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Provide;
